import React, { useEffect, useState } from "react"

import "./MonthView.scss"
import AppointmentCalendarUtils from "../../AppointmentCalenderUtils"
import EachDayOfMonth from "./components/EachDayOfMonth"

export default function MonthView({
  includeIpdOpdDivision,
  currentlySelected,
  appointments,
  onButtonClick,
  changeDay,
  outline,
  userRole,
  slotDuration,
  bedSlotDuration,
  show
}: any) {
  const week = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ]

  const [calendar, updateCalendar] = useState<any>()

  useEffect(() => {
    const tempCalendar = AppointmentCalendarUtils.getCurrentMonth(
      currentlySelected
    )
    updateCalendar(tempCalendar)
  }, [currentlySelected])

  function renderMonthView() {
    return (
      <div className="monthview">
        <div className="row m-0 col-md-12 col-lg-12 plr-12">
          {week.map((eachWeekDay) => (
            <div key={eachWeekDay} className="col">
              <div
                className={`dayOfWeek ${AppointmentCalendarUtils.checkCurrentWeekDay(eachWeekDay)
                  ? "selected"
                  : "not-selected"
                  }`}
              >
                <div className="day">{eachWeekDay}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="dayOfMonth">
          {calendar?.map((each: any, index: number) => (
            <div key={`monthview-${index}`}>
              <EachDayOfMonth
                day={{ each: each, index: index }}
                currentlySelected={currentlySelected}
                appointments={appointments}
                onButtonClick={onButtonClick}
                disablePopup={includeIpdOpdDivision}
                changeDay={changeDay}
                outline={outline}
                userRole={userRole}
                slotDuration={slotDuration}
                bedSlotDuration={bedSlotDuration}
                show={show}
              />
            </div>
          ))}
        </div>
      </div>
    )
  }

  return renderMonthView()
}
